import { render, staticRenderFns } from "./baseView.vue?vue&type=template&id=8a621cd0&scoped=true&"
import script from "./baseView.vue?vue&type=script&lang=js&"
export * from "./baseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a621cd0",
  null
  
)

export default component.exports